module.exports = __webpack_public_path__ + "static/media/PNG.adcff230.svg";